export default "__VITE_ASSET__b7f9cdf9__"